export const Method = {
    POST : 'post',
    GET : 'get',
    PUT : 'put',
    DELETE : 'delete',
}

export const ServicePath = {
    Dashboard : '/analytic/dashboard',
    GetUser : '/api/v1/user',
    Report : '/analytic/report',
    // AuthThinkAdmin : '/api/v1/login',
    // GetUser : '/api/v1/user',
    // AppList : '/api/v1/routes',
    // PermissionList : '/api/v1/permissions',
    // SearchUser : '/work/v3/portal-management',
    // GroupCreate : '/api/v1/group',
    // GroupList : '/api/v1/groups',
    // GroupById : '/api/v1/group'
}

export const Roles = {
    SUPER : 'super',
    ADMIN : 'admin',
    MEMBER : 'member',
    REPORTER : 'reporter',
}

export const Token = 'Token'